import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7249171a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toolbar = _resolveComponent("toolbar")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_list_header = _resolveComponent("ion-list-header")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_card_title = _resolveComponent("ion-card-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_stripe_card_token = _resolveComponent("stripe-card-token")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.$tr(_ctx.trCard, 'page'),
        backbutton: true
      }, null, 8, ["title"]),
      (_ctx.currencies)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            fullscreen: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_list, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_list_header, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_text, { color: "shiawasedo" }, {
                        default: _withId(() => [
                          _createVNode("h4", null, _toDisplayString(_ctx.$tr(_ctx.trCartForm, 'totalAmount')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { lines: "none" }, {
                    default: _withId(() => [
                      _createVNode("span", {
                        class: "total-amount",
                        innerHTML: _ctx.currencies[_ctx.order.currencyId].text
                      }, null, 8, ["innerHTML"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_card_title, {
                        color: "shiawasedo",
                        class: "card-title"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tr(_ctx.trCard, 'cardTitle')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withId(() => [
                      _createVNode(_component_stripe_card_token)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          (_ctx.AuthService.isAuth())
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_item, { lines: "none" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, {
                        class: "ion-text-wrap",
                        innerHTML: _ctx.$tr(_ctx.trCard, 'save')
                      }, null, 8, ["innerHTML"]),
                      _createVNode(_component_ion_checkbox, {
                        slot: "end",
                        modelValue: _ctx.saveCard,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveCard = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.appendCard())),
                expand: "block",
                disabled: _ctx.loading,
                color: "shiawasedo",
                type: "submit"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.loading ? _ctx.$tr(_ctx.trSignIn, 'loading') : _ctx.$tr(_ctx.trCard, 'pay')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})